import { useForm } from "@mantine/form";
import {
    TextInput,
    PasswordInput,
    Text,
    Paper,
    PaperProps,
    Button,
    Anchor,
    Stack,
    Alert,
    Group,
    Divider,
    ButtonProps,
} from "@mantine/core";
import { useMutation } from "react-query";
import { login } from "./Authentication";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IconAlertCircle } from "@tabler/icons-react";
import { GoogleIcon } from "./SocialButtons/GoogleIcon";
import { usePersistedStorage, useStorage } from "./ZustandState";

export interface LoginFormValues {
    username: string;
    password: string;
}

export function GoogleButton(props: ButtonProps) {
    return <Button leftSection={<GoogleIcon />} variant="default" color="gray" {...props} />;
}

export function LoginForm(props: PaperProps) {
    const navigate = useNavigate();
    const setSelectedPositionID = usePersistedStorage((state) => state.setSelectedPositionID);

    const form = useForm({
        initialValues: {
            username: "",
            password: "",
            terms: true,
        },
    });

    const mutation = useMutation({
        mutationFn: (values: LoginFormValues) => {
            return login(values.username, values.password);
        },
    });

    const { isLoading, isSuccess, isError, error } = mutation;
    if (isSuccess) {
        setSelectedPositionID(undefined);
        navigate("/");
    }

    let errorMessage = "";

    if (error) {
        errorMessage = error?.response?.data?.message || "Login failed";
    }

    return (
        <Paper radius="md" withBorder className="w-[30rem] p-12 max-w-[100vw] mt-[25%]" {...props}>
            <h1 className="mb-12">Sign in</h1>

            {/* <Group grow mb="md" mt="md">
                <GoogleButton radius="xl">Google</GoogleButton>
                <TwitterButton radius="xl">Twitter</TwitterButton>
            </Group>

            <Divider label="Or continue with" labelPosition="center" my="lg" /> */}

            <Group grow mb="md" mt="md">
                <GoogleButton
                    onClick={async () => {
                        // alert(
                        //     "Google login on openingTrainer temporarily disabled (will be fixed soon). Please login with username/password."
                        // );
                        window.location.href = `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/auth/google-ot`;
                    }}
                    radius="xl"
                >
                    Google
                </GoogleButton>
                {/* <TwitterButton radius="xl">Twitter</TwitterButton> */}
            </Group>
            <Divider label="Or continue with" labelPosition="center" my="lg" />

            {errorMessage && (
                // @ts-expect-error okk
                <Alert icon={<IconAlertCircle size="1rem" />} title={errorMessage} color="red" />
            )}
            <form
                onSubmit={form.onSubmit((values) => {
                    mutation.mutate(values);
                })}
            >
                <Stack>
                    <TextInput
                        required
                        withAsterisk={false}
                        label="Username or email"
                        value={form.values.username}
                        onChange={(event) => form.setFieldValue("username", event.currentTarget.value)}
                        error={form.errors.username && "Invalid username"}
                        radius="md"
                    />
                    <PasswordInput
                        required
                        withAsterisk={false}
                        label="Password"
                        value={form.values.password}
                        onChange={(event) => form.setFieldValue("password", event.currentTarget.value)}
                        error={form.errors.password && "Password should include at least 6 characters"}
                        radius="md"
                    />
                    <Anchor<"a"> href="/forgot-password" size="sm" ta="right">
                        Forgot password?
                    </Anchor>
                    <Button type="submit" loading={isLoading} fullWidth mt="xl" size="lg">
                        Sign in
                    </Button>
                    <Text ta="center" mt="md">
                        Don&apos;t have an account?{" "}
                        <Anchor<"a"> href="/register" weight={700}>
                            Register
                        </Anchor>
                    </Text>
                </Stack>
            </form>
        </Paper>
    );
}
